import React, { useState, useEffect } from "react";
import { Row, Col, Card, OverlayTrigger, Popover } from "react-bootstrap";
import AddServiceItems from "../BasketItems/ModalAddServiceItems/AddServiceItems";
import EditOrderPerson from "./ModalEditOrderPerson/EditOrderPerson";
import ViewHistoryOrderPerson from "./ModalViewHistoryOrderPerson/ViewHistoryOrderPerson";
import ApiOrderService from "../../../../../core/api/api.ordersService";
import SwalMessage from "../../../_Components/SwalMessage";
import TextField from "@mui/material/TextField";
import CopyToClipboard from "../../../_Components/CopyToClipboard";
import ModalHistoryTransaction from "../ModalHistoryItem/ModalHistoryTransaction";
import "./Style.css";
import { ViewAgentDetails } from "./ModalViewAgentDetails/ViewAgentDetails";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/CloseRounded";


function UserOrderPersonIndex(props) {
  const [showModalHistoryOrder, setShowModalHistoryOrder] = useState(false);
  const [showModalAddserviceItem, setShowModalAddserviceItem] = useState(false);
  const [showModalEditOrder, setShowModalEditOrder] = useState(false);
  const [showModalHistoryTransaction, setShowModalHistoryTransaction] = useState(false);
  const [showModalAgent, setShowModalAgent] = useState(false);

  const service = props.service;

  const handleShowHistoryOrder = () => {
    setShowModalHistoryOrder(!showModalHistoryOrder);
  };

  const handleshowEditOrder = () => {
    setShowModalEditOrder(!showModalEditOrder);
    props.callBack();
  };

  // const handleShowModalAddserviceItem = () => {
  //   setShowModalAddserviceItem(!showModalAddserviceItem);
  //   props.callBack();
  // };
  const handlerefreshFlag = () => {
    props.callBack();
  };
  const [smsDetails, setSmsDetails] = useState("");
  const handleSendAddressBasketId = (type) => {
    if (type == 1) {
      ApiOrderService.sendSmsLinkAddress({
        phoneNumber: props.service?.userOrderSelected?.phoneNumber,
        basketId: props.basketId,
      }).then((responce) => {
        SwalMessage({
          title: responce ? "ارسال پیامک لینک سفارش با موفقیت انجام شد " : "ارسال پیامک لینک سفارش با موفقیت انجام نشد",
          iSsuccess: responce,
          timer: 4000,
        });
      });
    }
    if (type == 2) {
      ApiOrderService.sendSmsOrderStatus({
        phoneNumber: props.service?.userOrderSelected?.phoneNumber,
        basketId: props.basketId,
        text: smsDetails,
      }).then((responce) => {
        SwalMessage({
          title: responce ? "ارسال پیامک با موفقیت انجام شد " : "ارسال پیامک انجام نشد",
          iSsuccess: responce,
          timer: 4000,
        });
      });
    }
  };

  let showPrice = Intl.NumberFormat("en-US");

  useEffect(() => {
    (async () => {
      try {
        if (props.service && props.service.basketItems && props.service.basketItems.length > 0) {
          let sms = "سفارش شماره " + props.basketId + "در وضعیت زیر قرار دارد ";

          let smsListOBJ = [];
          props.service.basketItems.forEach((item) => {
            //  ---- basketItems  ----
            if (item.basketItemPersons && item.basketItemPersons.length > 0) {
              item.basketItemPersons.forEach((itemPerson) => {
                // ---- basketItemPersons ------
                let index = smsListOBJ.findIndex(
                  (a) => a.basketItemId == item.id && a.currentStatusS == itemPerson.currentStatusS,
                );
                if (index != -1) {
                  // ویرایش
                  smsListOBJ[index].count += 1;
                } else {
                  // افزودن
                  const smsOBJ = {
                    basketItemId: item.id,
                    name: item.amusementServiceName,
                    currentStatusS: itemPerson.currentStatusS,
                    cancelStatusS: itemPerson.cancelStatusS,
                    count: 1,
                  };
                  smsListOBJ.push(smsOBJ);
                }
              });
            }
          });

          let text =
            smsListOBJ &&
            smsListOBJ
              .map((item) => {
                return " " + item.name + " " + item.count + " " + item.currentStatusS + " ";
              })
              .join("-");
          setSmsDetails(text);
        }
      } catch (error) {
      } finally {
      }
    })();
    return () => { };
  }, [props.service.basketItems]);

  return (
    <>
      {/* --------------------------مودال های مورد استفاده در این بخش--------------------------------------------------------------------------------------- */}
      {showModalHistoryOrder && <ViewHistoryOrderPerson callBack={handleShowHistoryOrder} basketId={props.basketId} />}
      {showModalEditOrder && (
        <EditOrderPerson callBack={handleshowEditOrder} basketId={props.basketId} person={service?.userOrderSelected} />
      )}
      {/* {showModalAddserviceItem && (
        <AddServiceItems
          callBack={handleShowModalAddserviceItem}
          basketId={props.basketId}
          basketItemPerson={props.service.basketPersons}
        />
      )} */}
      {showModalHistoryTransaction && (
        <ModalHistoryTransaction
          data={{ callBack: setShowModalHistoryTransaction, basketId: props.basketId }}
          show={showModalHistoryTransaction}
        />
      )}

      {/* --------------------------نمایش اطلاعات فرد سفارش دهنده -------------------------------------------------------------------------------------------- */}
      <Card className="bg-white w-100 mt-0 mb-4 p-3  rounded-xl  border border-secondary">
        <Row className="mb-4  border-bottom">
          <Col xs="12" xl="auto" className="d-flex align-items-center ml-2">
            {service?.basket?.creatorType == 1 ? (
              <>
                <h3 className="mr-3 mt-3  mb-3 cursor-pointer fs-large">
                  نماینده فروش: {service?.userOrderSelected?.firstName + " " + service?.userOrderSelected?.lastName}
                </h3>
              </>
            ) : (
              <div className="mb-3">
                <CopyToClipboard
                  showIcon={true}
                  copyDate={service?.userOrderSelected?.firstName + " " + service?.userOrderSelected?.lastName}
                  htmlText={
                    `<div className="m-0 p-0">
                      <h3 className="mx-3 mt-3 mb-0 text-hover-primary cursor-pointer fs-large" data-toggle="tooltip" data-placement="top" title="برای کپی کلیک کنید"
                        >` +
                    service?.userOrderSelected?.firstName +
                    " " +
                    service?.userOrderSelected?.lastName +
                    `</h3>
                    </div>`
                  }
                />
              </div>
            )}
          </Col>
          <Col className="">
            <Row className="justify-content-xl-end  mb-3 ">
              <Col xs="auto" className="pr-0 mb-2 mb-xl-0">
                <OverlayTrigger
                  trigger="click"
                  key="bottom"
                  placement="bottom"
                  rootClose
                  overlay={
                    <Popover id={"Popover-bottom"}>
                      <div
                        style={{
                          width: "300px",
                          height: "150px",
                          backgroundColor: "white",
                          display: "block",
                          zIndex: "200",
                          padding: 10
                        }}
                        onClick={(e) => {
                          e.stopPropagation()
                          e.preventDefault()
                        }}
                      >
                        <div className="position-relative">
                          <textarea
                            className="floating-input"
                            style={{
                              padding: "0.65rem",
                              paddingLeft: 25,
                              minHeight: 80
                            }}
                            value={smsDetails || ""}
                            onChange={(event) => {
                              setSmsDetails(event.target.value);
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Escape") {
                                const input = e.target;
                                if (input?.disabled) return
                                if (input) input.value = null;
                                const ev = new Event("input", { bubbles: true });
                                input.dispatchEvent(ev);
                                e.stopPropagation()
                              }
                            }}
                          />
                          <label className="floating-label text-secondary" style={{ right: 18 }}>جزییات</label>
                          <IconButton
                            type="button"
                            style={{
                              left: 25,
                              top: "50%",
                              transform: "translateY(-50%)",
                            }}
                            className="position-absolute translate-middle w-auto"
                            onClick={(e) => {
                              const input = e.currentTarget.closest(".postion-relative").querySelector("textarea");
                              if (input?.disabled || input?.readOnly) return
                              if (input) input.value = null;
                              const ev = new Event("input", { bubbles: true });
                              input.dispatchEvent(ev);
                            }}
                            size="small"
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </div>
                        <br></br>
                        <button
                          type="button"
                          className="btn btn-light btn-text"
                          onClick={() => handleSendAddressBasketId(2)}
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-custom-class="tooltip-dark"
                          title="ارسال وضعیت سفارش"
                          data-bs-delay-hide="1000"
                        >
                          ارسال پیامک<span>&nbsp;</span>
                        </button>
                      </div>
                    </Popover>
                  }
                >
                  <button
                    type="button"
                    className="btn btn-light btn-text"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    data-bs-custom-class="tooltip-dark"
                    title="ارسال وضعیت سفارش"
                    data-bs-delay-hide="1000"
                  >
                    ارسال وضعیت سفارش
                    <span>&nbsp;</span>
                    <p className="fa fa-sms fa-md my-0"></p>
                  </button>
                </OverlayTrigger>
              </Col>
              <Col xs="auto" className="pr-0 mb-2 mb-xl-0">
                <button
                  type="button"
                  className="btn btn-light  btn-text"
                  onClick={() => handleSendAddressBasketId(1)}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  data-bs-custom-class="tooltip-dark"
                  title="ارسال پیامک لینک سفارش"
                  data-bs-delay-hide="1000"
                >
                  پیامک لینک سفارش<span>&nbsp;</span>
                  <p className="fa fa-sms fa-md my-0"></p>
                </button>
              </Col>
              <Col xs="auto" className="pr-0 mb-2 mb-xl-0">
                <button type="button" className="btn btn-light-primary btn-text" onClick={handlerefreshFlag}>
                  <p className="fas fa-sync fa-sm my-0"></p>
                </button>
              </Col>
              {props.service?.permisionList?.filter((a) => a === "Pages.Basket.BasketTransaction").length > 0 && (
                <Col xs="auto" className="pr-0 mb-2 mb-xl-0">
                  <button
                    type="button"
                    className="btn btn-light-secondary btn-text"
                    onClick={() => setShowModalHistoryTransaction(!showModalHistoryTransaction)}
                  >
                    <p className="fas fa-credit-card text-dark fa-sm my-0"></p>
                  </button>
                </Col>
              )}
              <Col xs="auto" className="pr-0 mb-2 mb-xl-0">
                <button type="button" className="btn btn-light-secondary btn-text" onClick={handleShowHistoryOrder}>
                  <p className="fas fa-history text-dark fa-sm my-0"></p>
                </button>
              </Col>
              <Col xs="auto" className="mb-2 mb-xl-0">
                <button type="button" className="btn btn-light-primary btn-text" onClick={handleshowEditOrder}>
                  <p className="far fa-edit fa-sm my-0"></p>
                </button>
              </Col>
              {/* <Col xs="auto" className=" mb-xl-0 mb-2">
              <button
                type="button"
                className="btn btn-light-success btn-text"
                onClick={handleShowModalAddserviceItem}
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                data-bs-custom-class="tooltip-dark"
                title="اضافه کردن تفریحات به سبد"
                data-bs-delay-hide="1000"
              >
                <p className="fa fa-plus fa-md my-0"></p>
              </button>
            </Col> */}
            </Row>
          </Col>
        </Row>
        <Row>
          <Col xs="12 " sm="6" md="4" lg="6" xl="3" className="d-flex align-items-center text-hover-primary my-1">
            {service?.basket?.creatorType == 1 ? (
              <CopyToClipboard
                showIcon={true}
                copyDate={service?.basket?.mobile}
                htmlText={
                  `<span className="mx-3 cursor-pointer " data-toggle="tooltip" data-placement="top" title="برای کپی کلیک کنید"> <span className="text-hover-primary"> ` +
                  service?.basket?.mobile +
                  ` <i class="mr-2 fas fa-phone fa-sm text-hover-primary flipX"></i> </span>    </span>`
                }
              ></CopyToClipboard>
            ) : (
              <CopyToClipboard
                showIcon={true}
                copyDate={service?.userOrderSelected?.phoneNumber}
                htmlText={
                  `<span className="mx-3 cursor-pointer " data-toggle="tooltip" data-placement="top" title="برای کپی کلیک کنید"> <span className="text-hover-primary"> ` +
                  service?.userOrderSelected?.phoneNumber +
                  ` <i class="mr-2 fas fa-phone fa-sm text-hover-primary flipX"></i> </span>    </span>`
                }
              ></CopyToClipboard>
            )}
          </Col>
          <Col xs="12" sm="6" md="4" lg="6" xl="3" className=" d-flex align-items-center  my-1">
            <span className=" text-muted ">
              {" "}
              <small className="fas fa-shopping-basket"></small>
              <span className="mx-2 ">مجموع سبد خرید : {showPrice.format(service?.basket?.price)} تومان</span>
            </span>
          </Col>
          <Col xs="12" sm="6" md="4" lg="6" xl="3" className=" d-flex align-items-center my-1">
            <span className=" text-muted ">
              <small className="fas fa-gift"></small>
              <span className="mx-2 ">
                {" "}
                تخفیف:
                {service?.basket?.originalPrice && service?.basket?.salePrice
                  ? showPrice.format(service?.basket?.originalPrice - service?.basket?.salePrice)
                  : "---"}
              </span>
            </span>
          </Col>
          <Col xs="12" sm="6" md="4" lg="6" xl="3" className=" d-flex align-items-center my-1">
            <span className=" text-muted ">
              <small className="fas fa-gift"></small>
              <span className="mx-2">
                {" "}
                تخفیف کد:
                {service?.basket?.promoCodeDiscountPrice
                  ? showPrice.format(service.basket.promoCodeDiscountPrice)
                  : "---"}
              </span>
            </span>
          </Col>
          <Col xs="12" sm="6" md="4" lg="6" xl="3" className=" d-flex align-items-center my-1">
            <span className={`${service?.basket?.promoCodeCode ? " fw-bold text-info" : "text-muted"} `}>
              <small className="fas fa-gift"></small>
              <span className="mx-2">
                کد تخفیف:{service?.basket?.promoCodeCode ? service.basket.promoCodeCode : "---"}
              </span>
            </span>
          </Col>
          {service?.basket?.commisonAgentCompanyName && (
            <Col xs="12" sm="6" md="4" lg="6" xl="3" className=" d-flex align-items-center my-1">
              <span className={`d-inline-block btn btn-outline-info btn-sm`} onClick={() => setShowModalAgent(true)}>
                مشاهده جزئیات نماینده
              </span>
            </Col>
          )}
        </Row>
      </Card>
      {showModalAgent && (
        <ViewAgentDetails
          showModalAgent={showModalAgent}
          setShowModalAgent={setShowModalAgent}
          selectedAgent={service?.basket?.commisonAgentId}
        />
      )}
    </>
  );
}

export default UserOrderPersonIndex;
